import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IFullscreenModeState {
  fullscreenMode: boolean;
  fullscreenScaleFactor: number;
}

const initialState: IFullscreenModeState = {
  fullscreenMode: false,
  fullscreenScaleFactor: 1,
};

const fullscreenModeSlice = createSlice({
  name: 'fullscreenMode',
  initialState,
  reducers: {
    setFullscreenMode: (state, action: PayloadAction<boolean>) => {
      state.fullscreenMode = action.payload;
    },
    setFullscreenScaleFactor: (state, action: PayloadAction<number>) => {
      state.fullscreenScaleFactor = action.payload;
    },

    resetFullscreenMode: () => {
      return initialState;
    },
  },
});

export const { setFullscreenMode, setFullscreenScaleFactor, resetFullscreenMode } =
  fullscreenModeSlice.actions;

export const { reducer: fullscreenModeReducer } = fullscreenModeSlice;
